module.exports = __webpack_public_path__ + "img/13.6e07ce89.png";